export default __webpack_public_path__ + "static/media/Apparels.17765bb1.jpg";